<script setup lang="ts">
import { MODAL_TYPES, useModalStore } from '@/stores/modal';
import { COLOR_CLASSES } from '@/constants/colors';
import ModalFooterConfirmButtons from '@/components/modal/ModalFooterConfirmButtons.vue';

interface Props {
  title: string;
  message: string;
  modalType: string;
  confirmText?: string;
  cancelText?: string;
  isLoading?: boolean;
  showCancel?: boolean;
  messageClass?: string;
}

const props = withDefaults(defineProps<Props>(), {
  confirmText: '확인',
  cancelText: '취소',
  isLoading: false,
  showCancel: true,
});

const emit = defineEmits<Emits>();

interface Emits {
  (e: 'confirm'): void;
}

const modalStore = useModalStore();

const handleClose = () => {
  modalStore.close();
};
</script>

<template>
  <!-- <Teleport to="body"> -->
  <div
    v-if="modalStore.isOpen && modalStore.type === modalType"
    class="fixed inset-0 z-[9999] flex items-center justify-center w-full h-full"
  >
    <!-- 배경 오버레이 -->
    <div class="fixed inset-0 bg-[rgba(0,0,0,0.6)] w-full h-full" @click="handleClose" />

    <!-- 모달 컨텐츠 -->
    <div class="relative w-[350px] flex flex-col justify-center items-center bg-white shadow-xl px-4 py-3 rounded-lg">
      <div class="flex flex-col justify-center items-center py-3">
        <!-- 헤더 -->
        <h2 class="text-[20px] font-bold mb-4" :class="[COLOR_CLASSES.text.orange]">
          {{ title }}
        </h2>

        <!-- 컨텐츠 -->
        <p class="mb-6 text-base text-black text-center" :class="props.messageClass" v-html="message" />
      </div>

      <!-- 푸터 -->
      <div class="flex w-full mt-4">
        <ModalFooterConfirmButtons
          :cancel-text="cancelText"
          :confirm-text="confirmText"
          :disabled="false"
          :show-cancel="showCancel"
          :is-loading="isLoading"
          @cancel="handleClose"
          @confirm="emit('confirm')"
        />
      </div>
    </div>
  </div>
  <!-- </Teleport> -->
</template>
